export const TASK_CATEGORIES = [
  ["fitness", "Fitness"], ["study", "Study"], ["coding", "Coding"],
  ["work", "Work"], ["writing", "Writing"], ["reading", "Reading"],
  ["mindfulness", "Mindfulness"], ["life", "Life admin"], ["other", "Other"],
];

export const PARTNER_SUPPORT_OPTIONS = [
  ["remind", "Remind me"],
  ["cowork", "Work alongside me"],
  ["review", "Review my result"],
  ["ask", "Ask me about it"],
  ["verify", "Verify my completion"],
  ["celebrate", "Celebrate the win"],
];

export const categoryLabel = (key) => TASK_CATEGORIES.find(([value]) => value === key)?.[1] || "Other";
export const supportLabel = (key) => PARTNER_SUPPORT_OPTIONS.find(([value]) => value === key)?.[1] || key;
